import { axios, base } from '../http';

/**
 * 获取学校各校区团务考核配置
 * @param {Object} params { schoolId }
 */
export const getLeagueAffairConfigList = (params) => {
  return axios.get(`${base}/api/LeagueAffairConfig/GetConfigList`, { params });
};

/**
 * 获取指定校区值日加分项级联树
 * @param {Object} params { schoolId, campusId }
 */
export const getLeagueAffairAdditionItemTree = (params) => {
  return axios.get(`${base}/api/LeagueAffairConfig/GetAdditionItemTree`, { params });
};

/**
 * 保存某校区团务考核配置
 * @param {Object} data { schoolId, campusId, enabled, dutyInspectItemId }
 */
export const saveLeagueAffairConfig = (data) => {
  return axios.post(`${base}/api/LeagueAffairConfig/SaveConfig`, data);
};

/**
 * 分页查询团务考核签到记录
 * @param {Object} params { schoolId, campusId, classId, studentName, startDate, endDate, yearMonth, page, intPageSize }
 */
export const getLeagueAffairCheckInRecords = (params) => {
  return axios.get(`${base}/api/LeagueAffair/GetCheckInRecords`, { params });
};

/**
 * 导出团务考核签到记录（Excel blob）
 * @param {Object} params 同列表查询（可不带分页）
 */
export const exportLeagueAffairCheckInRecords = (params) => {
  return axios.get(`${base}/api/LeagueAffair/ExportCheckInRecords`, {
    params,
    responseType: 'blob',
    skipGlobalHttpErrorToast: true
  });
};

/**
 * 某月完成汇总（支持分页）
 * @param {Object} params { schoolId, yearMonth, campusId, completionFilter, page, intPageSize }
 */
export const getLeagueAffairCompletionSummary = (params) => {
  return axios.get(`${base}/api/LeagueAffair/GetCompletionSummary`, { params });
};
